import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo, useState } from "react";
export const PDFViewerOutlinePageMenu = /*#__PURE__*/ memo((param)=>{
    let { pageNumber, renderOutlinePageMenu } = param;
    const [isMenuOpen, setMenuIsOpen] = useState(false);
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("absolute right-2 top-2 hidden group-focus-within/outline-page:flex group-hover/outline-page:flex group-active/outline-page:flex", isMenuOpen ? "flex" : ""),
        children: renderOutlinePageMenu({
            pageNumber,
            setMenuIsOpen
        })
    });
});
PDFViewerOutlinePageMenu.displayName = "PDFViewerOutlinePageMenu";
